import http from "../http-common";

class ProjectDataService {
  getAll() {
    return http.get("/projectstructure");
  }

  get(id) {
    return http.get(`/projectstructure/${id}`);
  }

  getByProject(id) {
    return http.get(`/projectstructure/getByProject/${id}`);
  }

  create(data) {
   
    if(data.file)
    data.fileName = data.file.name;
    else
    data.fileName = "";
    return http.post("/projectstructure", data);
  }

  update(id, data) {

    if(data.file)
    data.fileName = data.file.name;
    else
    data.fileName = "";

    return http.put(`/projectstructure/${id}`, data);
  }

  delete(id) {
    return http.delete(`/projectstructure/${id}`,);
  }

  deleteAll() {
    return http.delete(`/projectstructure`, );
  }

  findByTitle(title) {
    return http.get(`/projectstructure?title=${title}`,);
  }

  cloneProject(data) {
    return http.post("/projectstructure/clone", data);
  }

}

export default new ProjectDataService();